import React from 'react';
import Text from 'components/Text';
import useUniqueId from 'hooks/useUniqueId';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function SimpleListItem(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle;
  var titleId = useUniqueId();
  return /*#__PURE__*/_jsxs("article", {
    "aria-labelledby": titleId,
    children: [/*#__PURE__*/_jsx(Text, {
      bold: true,
      as: "h4",
      size: "s",
      id: titleId,
      children: title
    }), subtitle && /*#__PURE__*/_jsx(Text, {
      as: "div",
      size: "xs",
      children: subtitle
    })]
  });
}
export default SimpleListItem;